<template>
  <div
    v-if="reviews"
    class="catalog-reviews-component"
  >
    <carousel
      :tile-count="tileCount"
      tile-type="catalog-review"
      :item-width="360"
      @handle-carousel-navigated="sendAnalytics"
      @scroll-event="handleCarouselScroll"
    >
      <div
        v-for="review in reviews"
        :key="review.id"
        :ref="'reviewCards'"
        class="review-card"
      >
        <div class="review-card-content">
          <div class="review-title-date">
            <p>{{ review.title }}</p>
            <span v-if="review.reviewDate">{{ formatDate(review.reviewDate) }}</span>
          </div>
          <p class="review-text">
            {{ stripHtml(review.reviewText) }}
          </p>
          <span>{{ review.byLine }}</span>
        </div>
      </div>
    </carousel>
    <pagination-indicator
      class="review-pagination"
      :active-index="activeReviewIndex"
      :total="reviews.length"
    />
  </div>
</template>

<script>
import Carousel from '@components/carousels/carousel';
import PaginationIndicator from '@components/ui/pagination-indicator.vue';

import { format } from 'date-fns';
import { stripHtml } from '@/utils';

export default {
  components: { Carousel, PaginationIndicator },
  props: {
    catalogPage: {
      type: Object,
    },
    reviews: {
      type: Array,
      default: null,
    },
  },
  data() {
    return  {
      activeReviewIndex: 0, // This is only used at mobile screen sizes
    };
  },
  computed: {
    tileCount() {
      return this.reviews.length;
    },
  },
  methods: {
    formatDate(date) {
      return format(new Date(date), 'MMM d');
    },
    handleCarouselScroll({ position, width }) {
      // This is the logic that we use to determine the scroll position of the middle of the carousel
      // The carousel will emit the position of the left scroll bound and the width of the carousel container
      // We can take half the width, add it to the position and get approximately the center of the screen
      // We can use any of the refs on the reviewCards to get the current width of the card and by dividing
      // the visible middle of the screen by the width of the tile plus the margin, we can determine if
      // the left bound of a given tile has crossed the center threshold and if it has, we can update active
      // index to that of the tile crossing the middle.
      const firstCard = this.$refs.reviewCards?.[0];
      const cardWidth = firstCard?.getBoundingClientRect()?.width;
      if (cardWidth) {
        const widthWithMargin = cardWidth + 16;
        const visibleMiddle = position + (width / 2);
        this.activeReviewIndex = Math.floor(visibleMiddle / widthWithMargin);
      }
    },
    sendAnalytics() {
      this.$analytics.events.viewedAddOnReviews(this.catalogPage);
    },
    stripHtml,
  },
};
</script>

<style lang="scss" scoped>
.catalog-reviews-component {
  margin-bottom: 5rem;

  :deep(.tile-container) {
    height: rem-calc(196);
  }

  .review-card {
    display: inline-flex;
    box-sizing: border-box;
    width: rem-calc(344);
    max-width: 80%;
    min-height: 9rem;
    margin-right: 1rem;
    padding: 1rem;
    background-color: #f7f7f7;
    border-top: solid 4px #00d8f8;
    border-radius: 4px;
    white-space: initial;

    .review-card-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: rem-calc(14);
      line-height: 1.43;

      p {
        margin: 0;
      }
      .review-text {
        padding: 1rem 0;
      }
      span {
        color: #717171;
      }

      .review-title-date {
        display: flex;
        justify-content: space-between;

        p {
          font-weight: $bold;
          color: #000000;
        }
      }
    }
  }

  .review-pagination {
    display: none;

    @include breakpoint(small) {
      display: flex;
    }
  }
}
</style>
